import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  border-radius: 5rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  color: inherit;
`;

type Props = {
  number: number;
} & React.HTMLProps<HTMLDivElement>;
const NotificationNumber: FC<Props> = ({ number, style }) => {
  return number ? <Container style={style}>{number}</Container> : null;
};

export default NotificationNumber;
